import { render } from "./ShortcutsInfo.vue?vue&type=template&id=55fb44f9&scoped=true&ts=true"
import script from "./ShortcutsInfo.vue?vue&type=script&lang=ts"
export * from "./ShortcutsInfo.vue?vue&type=script&lang=ts"

import "./ShortcutsInfo.vue?vue&type=style&index=0&id=55fb44f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fb44f9"]])

export default __exports__